// Nav Constants ---------------------------------------------------------------------------------------------------------------------------

export const NAV_HEADER_THEME_STORAGE_NAME = "cloud-admin";

export const NAV_HEADER_NAME = {
  Prefix: "cloud",
  Suffix: "admin",
};
